import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { languageHelper } from "../../../config/helperFunctions";
import DeleteModal from "../../../components/Modal/DeleteModal";

function Suppliers() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Name"),
      accessorKey: "name",
    },
    {
      header: languageHelper("Contact Person"),
      accessorKey: "contact_person",
    },

    {
      header: languageHelper("Phone"),
      accessorKey: "phone",
    },
    {
      header: languageHelper("Supplier VAT"),
      accessorKey: "supplier_vat",
    },
    {
      header: languageHelper("Email"),
      accessorKey: "email",
    },
    {
      header: languageHelper("Address"),
      accessorKey: "address",
    },
    {
      header: languageHelper("Description"),
      accessorKey: "description",
    },
    {
      header: languageHelper("Added By"),
      cell: (row) => row.row.original.user?.name,
    },
    {
      header: languageHelper("Actions"),
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const buttonData = [
    {
      buttonText: languageHelper("Add Supplier"),
      path: "addSuplierForm",
    },
  ];

  const navigate = useNavigate();

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`addSuplierForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => setDeleteId(id),
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/suppliers/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchData();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/suppliers`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error Occured");
      })
      .finally(() => setPageLoading(false));
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Suppliers")}
        buttonData={buttonData}
      />
      {deleteId && (
        <DeleteModal
          setIsOpen={setDeleteId}
          onDelete={() => handleDelete(deleteId)}
        />
      )}
    </main>
  );
}

export default Suppliers;
